<template>
	<div>
		<!-- Two sidebars, one for mobile and the other below for desktop -->

		<navbar v-if="isAuthenticated" />

		<div class="d-block d-lg-none" v-if="isAuthenticated && sidebarOpen">
			<sidebar />
		</div>

		<main>
			<div class="row no-gutters">
				<div class="col-12 col-md-4 col-lg-3 col-xl-2 d-none d-lg-block" v-if="isAuthenticated">
					<sidebar />
				</div>
				<div class="col p-5">
					<router-view />
				</div>
				<notifications position="bottom left" />
			</div>
		</main>
	</div>
</template>

<script type="text/javascript">
	import Sidebar from './Sidebar';
	import Navbar from './Navbar';
	import {mapState, mapGetters} from 'vuex';
	import EventBus from '../event-bus';

	export default {
		computed: {
			...mapState({
				sidebarOpen: state => state.sidebarOpen,
			}),

			...mapGetters({
				isAuthenticated: 'auth/isAuthenticated',
			}),
		},

		mounted() {
			EventBus.$on('notification', n => {
				this.$notify({
					title: 'New!',
					text: n.formatted_content,
					type: 'warn',
					duration: -1,
				});

				this.$store.dispatch('notifications/fetchAll');
			});
		},
		
		components: {
			'sidebar': Sidebar,
			'navbar': Navbar,
		},

		meta: {
			title: '404',
			titleTemplate: '%s / Al-Shayah',

			meta: [
				{name: 'og:image', content: '/src/images/dashboard/le-pirate-logo.png', vmid: 'og:image'},
			]
		},
	};
</script>

<style scoped>
	.row {
		flex-wrap: nowrap;
	}

	.row > .col {
		overflow-x: auto;
	}
</style>
